import React from 'react';
import { HiLink } from 'react-icons/hi';
import SettingsSection from './SettingsSection';
import Select from '../common/Select';
import PasswordInput from '../common/PasswordInput';
import Toggle from '../common/Toggle';
import NumberInput from '../common/NumberInput';
import { useSettings } from '../../context/SettingsContext';

const ApiSettings = () => {
  const { settings, updateSettings } = useSettings();
  const { api } = settings;

  const providerOptions = [
    { value: 'mock', label: 'Mock (시뮬레이션)' },
    { value: 'kiwoom', label: '키움증권' },
    { value: 'korea_investment', label: '한국투자증권' },
  ];

  const modeOptions = [
    { value: 'simulation', label: '시뮬레이션' },
    { value: 'real', label: '실전' },
  ];

  return (
    <SettingsSection title="API 연결" icon={HiLink}>
      {/* API 키 관리 */}
      <div>
        <h4 className="text-sm font-semibold text-gray-300 mb-3">API 키 관리</h4>
        <div className="space-y-4">
          <Select
            label="API 제공자"
            value={api.apiProvider}
            onChange={(value) => updateSettings('api', 'apiProvider', value)}
            options={providerOptions}
          />
          <PasswordInput
            label="API 키"
            value={api.apiKey}
            onChange={(value) => updateSettings('api', 'apiKey', value)}
            placeholder="API 키를 입력하세요 (Mock)"
          />
          <PasswordInput
            label="API 시크릿"
            value={api.apiSecret}
            onChange={(value) => updateSettings('api', 'apiSecret', value)}
            placeholder="API 시크릿을 입력하세요 (Mock)"
          />
        </div>
      </div>

      {/* 연결 설정 */}
      <div>
        <h4 className="text-sm font-semibold text-gray-300 mb-3">연결 설정</h4>
        <div className="space-y-4">
          <Select
            label="API 모드"
            value={api.apiMode}
            onChange={(value) => updateSettings('api', 'apiMode', value)}
            options={modeOptions}
          />
          <Toggle
            label="자동 재연결"
            checked={api.autoReconnect}
            onChange={(value) => updateSettings('api', 'autoReconnect', value)}
          />
          {api.autoReconnect && (
            <NumberInput
              label="재연결 대기 시간"
              value={api.reconnectDelay}
              onChange={(value) => updateSettings('api', 'reconnectDelay', value)}
              min={1}
              max={60}
              step={1}
              unit="초"
            />
          )}
        </div>
      </div>

      {/* 연결 상태 */}
      <div>
        <h4 className="text-sm font-semibold text-gray-300 mb-3">연결 상태</h4>
        <div className="bg-gray-700/50 rounded-lg p-4 space-y-3">
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-400">상태</span>
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 rounded-full bg-green-500"></div>
              <span className="text-sm text-green-500">정상 연결 (Mock)</span>
            </div>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-400">마지막 연결</span>
            <span className="text-sm text-white">
              {new Date().toLocaleString('ko-KR')}
            </span>
          </div>
          <button
            type="button"
            className="w-full button bg-blue-500 hover:bg-blue-600 text-white"
          >
            연결 테스트
          </button>
        </div>
      </div>
    </SettingsSection>
  );
};

export default ApiSettings;
